export default "__VITE_ASSET__BMSUcQQV__"